import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

// 开发者账号一级
const developerRouter: RouteConfig = {
  path: '/developer',
  component: Layout,
  redirect: '/developer/developer-private/developer-private-account',
  meta: {
    title: '签名',
    icon: 'menu-apple'
  },
  children: [
    {
      name: 'DeveloperPrivate',
      path: 'developer-private',
      component: () => import('@/views/developer/developer-private/index.vue'),
      redirect: '/developer/developer-private/developer-private-account',
      meta: {
        title: '个人账号签名'
      },
      children: [
        {
          name: 'DeveloperPrivateAccount',
          path: 'developer-private-account',
          component: () => import('@/views/developer/developer-private/account.vue'),
          meta: {
            title: '账号管理'
          }
        },
        {
          name: 'DeveloperPrivateSignature',
          path: 'developer-private-signature',
          component: () => import('@/views/developer/developer-private/signature.vue'),
          meta: {
            title: '签名信息'
          }
        },
        {
          name: 'DeveloperPrivateUserInitialSignature',
          path: 'developer-private-userInitialSignature',
          component: () => import('@/views/developer/developer-private/userInitialSignature.vue'),
          meta: {
            title: '用户初签列表'
          }
        },
        {
          name: 'DeveloperPrivateUserReturnManagement',
          path: 'developer-private-userReturnManagement',
          component: () => import('@/views/developer/developer-private/userReturnManagement.vue'),
          meta: {
            title: '用户回签管理'
          }
        },
        {
          name: 'DeveloperPrivateBlacklist',
          path: 'developer-private-blacklist',
          component: () => import('@/views/developer/developer-private/blacklist.vue'),
          meta: {
            title: '黑名单'
          }
        },
        {
          name: 'DeveloperPrivateWhitelist',
          path: 'developer-private-whitelist',
          component: () => import('@/views/developer/developer-private/whitelist.vue'),
          meta: {
            title: '白名单'
          }
        },
        {
          name: 'DeveloperPrivateSignatureSettings',
          path: 'developer-private-signatureSettings',
          component: () => import('@/views/developer/developer-private/signatureSettings.vue'),
          meta: {
            title: '白名单'
          }
        }
      ]
    },
    {
      name: 'DeveloperCompany',
      path: 'developer-company',
      component: () => import('@/views/developer/developer-company/index.vue'),
      redirect: '/developer/developer-company/developer-company-account',
      meta: {
        title: '企业账号P12签名'
      },
      children: [
        {
          name: 'DeveloperCompanyAccount',
          path: 'developer-company-account',
          component: () => import('@/views/developer/developer-company/account.vue'),
          meta: {
            title: '账号管理'
          }
        },
        {
          name: 'DeveloperCompanySignature',
          path: 'developer-company-signature',
          component: () => import('@/views/developer/developer-company/signature.vue'),
          meta: {
            title: '签名信息'
          }
        },
        {
          name: 'DeveloperCompanyApp',
          path: 'developer-company-app',
          component: () => import('@/views/developer/developer-company/app.vue'),
          meta: {
            title: '签名应用管理'
          }
        },
        {
          name: 'DeveloperCompanyFreeApp',
          path: 'developer-company-free',
          component: () => import('@/views/developer/developer-company/free.vue'),
          meta: {
            title: '免费应用管理'
          }
        }
      ]
    },
    {
      name: 'DeveloperWeek',
      path: 'developer-week',
      component: () => import('@/views/developer/developer-week/index.vue'),
      redirect: '/developer/developer-week/developer-week-signature',
      meta: {
        title: '开发者帐号签名'
      },
      children: [
        {
          name: 'DeveloperWeekAccount',
          path: 'developer-week-account',
          component: () => import('@/views/developer/developer-week/account.vue'),
          meta: {
            title: '帐号管理（7天）'
          }
        },
        {
          name: 'DeveloperWeekSignature',
          path: 'developer-week-signature',
          component: () => import('@/views/developer/developer-week/signature.vue'),
          meta: {
            title: '签名信息'
          }
        },
        {
          name: 'DeveloperWeekConfig',
          path: 'developer-week-config',
          component: () => import('@/views/developer/developer-week/config.vue'),
          meta: {
            title: '签名配置'
          }
        },
        {
          name: 'DeveloperWeekApp',
          path: 'developer-week-app',
          component: () => import('@/views/developer/developer-week/app.vue'),
          meta: {
            title: '7天签名应用管理'
          }
        }
      ]
    }
  ]
}

export default developerRouter
